import { Component, Input, OnChanges, OnDestroy, SimpleChanges, SimpleChange } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { debounceTime, from, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { AccountingProcessingItem, AccountingProcessingService, GetAccountingProcessingsParams } from '../accounting-processing.service';

@Component({
    selector: 'tt-accounting-processing-list',
    templateUrl: './accounting-processing-list.component.html',
    styleUrls: ['./accounting-processing-list.component.css'],
})
export class AccountingProcessingListComponent implements OnChanges, OnDestroy {
    @Input()
    public custactNo: string = '';

    @Input()
    public businessCoNo: string = '';

    @Input()
    public accountingFunction: string = '';

    @Input()
    public searchText = '';

    private destroy$ = new Subject<void>();

    private load$ = new Subject<GetAccountingProcessingsParams>();

    public accountingProcessings: AccountingProcessingItem[] = [];

    constructor(private accountingProcessing: AccountingProcessingService) {
        this.load$
            .pipe(
                takeUntil(this.destroy$),
                tap({ next: () => (this.accountingProcessings = []) }),
                debounceTime(50),
                switchMap((params) => from(this.accountingProcessing.getAccountingProcessings(params))),
            )
            .subscribe({ next: (list) => (this.accountingProcessings = list) });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((this.isNewAndValidChange(changes['accountingFunction']) || this.isNewAndValidChange(changes['businessCoNo']) || this.isNewAndValidChange(changes['custactNo'])) && !!this.accountingFunction && this.accountingFunction !== 'all') {
            this.load$.next({ custact_no: this.custactNo, businessco_no: this.businessCoNo, accountingfunction: this.accountingFunction });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.load$.complete();
    }

    private isNewAndValidChange(change: SimpleChange | undefined) {
        return !!change && (change.firstChange || change.currentValue !== change.previousValue);
    }
}
